import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseSiteService, OCC_USER_ID_CURRENT, UserIdService, WindowRef } from '@spartacus/core';
import { PageLayoutService } from '@spartacus/storefront';
import { BehaviorSubject, map, Subscription, switchMap } from 'rxjs';
import { ThemeService } from './spartacus/features/store-front/misc/theme/core/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Marathon Electric LLC | Electric Motors | Generators';
  theme$ = new BehaviorSubject('');
  baseSite$ = this.baseSiteService
    .getActive()
    .pipe(switchMap((baseSiteID: string) => this.baseSiteService.get(baseSiteID)));
  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));

  subscriptions = new Subscription();

  constructor(
    private baseSiteService: BaseSiteService,
    private pageLayoutService: PageLayoutService,
    private winRef: WindowRef,
    private styleThemeService: ThemeService,
    private userIdService: UserIdService,
  ) {}

  ngOnInit(): void {
    this.getCMSConfigs();

    // setTimeout(() => {
    // 	const button = this.winRef.document?.querySelector('[title="PSR 960"]') as any;
    // 	button.click();
    // }, 1000);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getCMSConfigs() {
    // this.getTheme();

    this.subscriptions.add(
      this.baseSite$.subscribe((baseSite: any) => {
        const theme = `main-base-site ${baseSite.theme}`;
        this.theme$.next(theme);
        this.winRef.isBrowser() &&
          theme.split(' ').forEach((className: string) => this.winRef.document.body.classList.add(className));
      }),
    );

    this.subscriptions.add(
      this.pageLayoutService.page$.subscribe(page => {
        page.pageId &&
          this.winRef.isBrowser() &&
          this.winRef.document.body.setAttribute('data-page-id', page.pageId ?? '');
        page.template &&
          this.winRef.isBrowser() &&
          this.winRef.document.body.setAttribute('data-page-template', page.template ?? '');
      }),
    );
  }

  getTheme() {
    this.subscriptions.add(
      this.styleThemeService.get().subscribe(theme => {
        this.styleThemeService.applyTheme(theme);
      }),
    );

    this.styleThemeService.fetch();
  }
}
